export const Banner_id = 1;
export const Solution_id = 2;
export const Contact_id = 3;